import Image from 'next/image'

export default function TeamMemberItem(props)
{
    const { className, firstName, lastName, title, bio, image } = props;

    let titleContent, bioContent;

    if (title) {
        titleContent = ( <p className="pb-20">{ title }</p> );
    }

    if (bio) {
        bioContent = (
            <div className="sol-markdown-content">{ bio }</div>
        );
    }

    return (
        <div className={ "sm:flex sm:gap-40" + (className ? " " + className : "") }>
            <div className="mb-20 sm:mb-0 shrink-0 relative w-[150px] h-[150px] border-2 border-grey">
                <div className="relative w-full h-full">
                    <Image src={ image } alt={ firstName + (firstName ? " " + lastName : "") } layout="responsive" objectFit="cover" />
                </div>
            </div>
            <div className="text-left">
                <h4 className="text-h2">{ firstName + (firstName ? " " + lastName : "") }</h4>
                { titleContent }
                { bioContent }
            </div>
        </div>
    );
}